<template>
  <div class="login  text-center">
    <div class="login-content">
      <h1 class="margin-b-15">九江电子商务大数据系统</h1>
      <p class="text-A6E7FF margin-b-40 font-18">JIUJIANG E-COMMERCE BIG DATA SYSTEM</p>
      <el-form :model="loginInfo" :rules="loginRules" ref="loginInfo" class="">
        <div>
          <el-form-item label="" prop="username" class="margin-b-35 margin-t-20">
            <el-input type="text" placeholder="请输入账号" prefix-icon="el-icon-s-custom"
                      v-model="loginInfo.username" v-on:keyup.enter.native="login('loginInfo')">
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" v-model="loginInfo.password"
                      v-on:keyup.enter.native="login('loginInfo')">
            </el-input>
          </el-form-item>
          <el-form-item label=""  prop="code" class="code">
            <el-input v-model="loginInfo.code" placeholder="请输入右侧验证码"  style=" width: 70%; float:left;"></el-input>
            <div class="get-code" @click="refreshCode()">
              <s-identify :identifyCode="generatedCode"></s-identify> <!-- 改为生成的验证码 -->
            </div>
          </el-form-item>
          <el-button class="login-button" v-on:click="login('loginInfo')">登录</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import SIdentify from "@/components/SIdentify.vue";
  export default {
    name: 'login',
    components: { SIdentify },
    data () {
      return {
        loginInfo: {}, // 登录表单数据
        generatedCode: "", // 系统生成的验证码（新增）
        identifyCodes: "123456789abcdwerwshdjeJKDHRJHKPLMKQ", // 验证码字符池
        loginRules: {
          username: [
            {required: true, message: '请输入账号！', trigger: 'change'}
          ],
          password: [
            {required: true, message: '请输入密码！', trigger: 'change'}
          ],
          code: [
            { validator: this.validateCode, trigger: 'blur' } // 校验函数移到methods
          ],
        },
        activeMenuIndex:'/index', // 菜单默认选中项
      }
    },
    created: function () {
      this.$emit('public_header', false);
      this.refreshCode(); // 初始化生成验证码
    },
    methods: {
      // 验证码校验函数
      validateCode(rule, value, callback) {
        if (value === '') {
          callback(new Error('请输入验证码！'));
        } else if (value.toLowerCase() !== this.generatedCode.toLowerCase()) {
          callback(new Error('验证码错误！'));
        } else {
          callback();
        }
      },
      // 刷新验证码
      refreshCode() {
        this.generatedCode = ''; // 清空生成的验证码
        this.makeCode(this.identifyCodes, 4); // 生成新验证码
      },
      // 生成随机数
      randomNum(min, max) {
        max = max + 1;
        return Math.floor(Math.random() * (max - min) + min);
      },
      // 生成验证码字符串
      makeCode(data, len) {
        for (let i = 0; i < len; i++) {
          this.generatedCode += data[this.randomNum(0, data.length - 1)];
        }
      },
      // 登录逻辑
      login (loginInfo) {
        this.$refs[loginInfo].validate((valid) => {
          if (valid) {
            // 密码MD5加密（先备份原始密码，避免加密后重复加密）
            const rawPwd = this.loginInfo.password;
            this.loginInfo.password = this.$md5(rawPwd);

            // 提交登录请求（补充catch捕获所有请求错误）
            this.$http.post(this.header + '/login/loginCheck', JSON.stringify(this.loginInfo))
              .then(res => {
                // 兼容vue-resource的响应格式（res.body 而非 res.data）
                const response = res.body || res.data || {};
                if (response.code == 0) {
                  // 存储用户信息和token
                  sessionStorage.setItem('userInfo', JSON.stringify(this.loginInfo));
                  sessionStorage.setItem('xybdsToken', response.xybdsToken || '');

                  // 不同账号跳转到对应路由
                  const cityIndexUsers = [
                    'wnx_2025', 'xsx_2025', 'yyx_2025', 'dax_2025',
                    'dcx_2025', 'hkx_2025', 'pzx_2025', 'rcs_2025',
                    'gqcs_2025', 'lss_2025', 'csq_2025', 'xyq_2025',
                    'lxq_2025', 'jkq_2026'
                  ];
                  const targetPath = cityIndexUsers.includes(this.loginInfo.username) ? '/CityIndex' : '/index';
                  // const targetPath = '/CityIndex';
                  this.activeMenuIndex = targetPath; // 同步菜单选中项

                  // 适配 vue-router@3.0.1 的跳转写法（仅支持成功回调，无失败回调）
                  this.$router.push({ path: targetPath }, () => {
                    this.$nextTick(() => {
                      // 跳转成功后的逻辑（可选）
                    });
                  });

                  this.refreshCode(); // 刷新验证码
                } else {
                  this.refreshCode(); // 刷新验证码
                  this.$alert(response.msg || '登录失败，请重试');
                }
              })
              // 捕获所有请求错误（网络/接口/解析错误）
              .catch(err => {
                console.error('登录请求失败：', err);
                this.refreshCode();
                // 恢复原始密码，避免加密后下次登录密码错误
                this.loginInfo.password = rawPwd;
                this.$alert('登录请求失败，请检查网络或联系管理员');
              });
          } else {
            return false;
          }
        });
      },
      // 备用提交方法（可保留）
      submit(){
        this.$refs.form.validate((valid) => {
          if(valid){
            getMenu(this.form).then(({ data }) => {
              console.log(data);
              if(data.code === 20000){
                this.$store.commit('setMenu',data.data.menu);
              }else{
                this.$message.error(data.data.message);
              }
            });
          }
        });
      },
    }
  }
</script>

<style>
  .login .el-input__icon {
    font-size: 26px;
    width: 45px;
    color: #20A3F5;
  }

  .login .el-input__inner {
    background-color: rgba(24,136,203,0.3) !important;
    border:3px solid rgba(32,163,245,0.4) !important;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    color: white;
  }

  .login {
    background: url("../assets/login-bg.png") no-repeat 100% 100% !important;
    background-size: 100% 100% !important;
    padding-top: 80px;
    padding-bottom: 237px !important;
    margin-left: 0px !important;
  }

  @media screen and (max-width: 1280px) {
    .login .login-content {
      width: 631px;
      margin-top: 40px;
      margin-left: 23%;
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1200px) {
    .index {
      /*width: 770px;*/
    }
  }

  @media screen and (min-width: 1300px) and (max-width: 1600px) {
    .login .login-content {
      width: 631px;
      margin-top: 60px;
      margin-left: 42%;
    }
  }

  @media screen and (min-width: 1600px) {
    .login .login-content {
      width: 631px;
      margin-top: 40px;
      margin-left: 40%;
    }
  }

  @media screen and (min-width: 1900px) {
    .login .login-content {
      width: 631px;
      margin-top: 100px;
      margin-left: 32%;
    }
  }
  .login .login-content h1 {
    background: linear-gradient(0deg, rgba(0, 159, 241, 1) 0%, rgba(0, 232, 207, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size:41px;
  }

  .login form h2 {
    color: rgba(0, 191, 244, 1);
    text-align: center;
    padding-top: 30px;
  }

  .login form {
    width: 631px;
    height: 500px;
    padding: 80px 100px 0 100px;
    background:url("../assets/login-content-bg.png") no-repeat 100% 100%;
    background-size: 100% 100% !important;
  }

  .login-left p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #0D388F;
  }

  .login .el-input--prefix .el-input__inner {
    padding-left: 50px;
  }

  .login .el-input {
    width: 100%;
    height: 50px;
  }

  .login .login-button {
    width:100%;
    height:50px;
    background:rgba(32,163,245,1) !important;
    border-radius:2px;
    font-size: 26px;
    color: white !important;
    border: none;
  }

  .login-button .el-button:focus, .login-button .el-button:hover {
    background: linear-gradient(90deg, rgba(111, 178, 255, 1), rgba(9, 95, 255, 1)) !important;
    color: white !important;
  }
  .code ::v-deep .el-input__inner{
    width: 313px!important;
  }
  .code-img {
    width: 30%;
    height: 50px;
    float: right;
    margin-top: -65px;
    margin-right: 270px;
    text-align: center;
    background: #dbdbdb;
  }
  .login .el-form-item__error {
    padding-top: 10px!important;
    margin-left: 50px;
  }
  .code .el-form-item__error {
    padding-top: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue